import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
const MINUTES = ['2', '4', '6', '9', '11', '14', '18', '21'];

/**
 * Recurring social-proof toast showing recent purchases.
 */
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const cycle = () => {
      setVisible(true);
      timeoutId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % buyers.length);
        timeoutId = window.setTimeout(cycle, 9000);
      }, 6000);
    };
    timeoutId = window.setTimeout(cycle, 7000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed, index]);
  const buyer = buyers[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-43" data-mp="164xqn44510nq">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[104px] left-3 z-50 w-[min(19rem,calc(100vw-1.5rem))] rounded-2xl bg-white p-3 shadow-[0_16px_40px_-12px_rgba(8,24,47,0.4)] ring-1 ring-navy-800/10 sm:bottom-24 sm:left-5" role="status" aria-live="polite" data-id="element-44" data-mp="116w8qmig77du">
          <div className="flex items-start gap-3" data-id="element-45" data-mp="x515hcgyijxf">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-aqua-50" data-id="element-46" data-mp="x6m2d8qqueyg">
              <CheckCircle2Icon className="h-5 w-5 text-aqua-500" aria-hidden="true" data-id="element-47" data-mp="s8av95ru2ijx" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-48" data-mp="28maqi3fqhk0u">
              <p className="text-[13px] font-bold leading-tight text-navy-800" data-id="element-49" data-mp="23m66w4jj496e">
                {buyer.name} <span className="font-medium text-navy-800/70" data-id="element-50" data-mp="2apcrmzy5v1hx">just purchased</span>
              </p>
              <p className="mt-0.5 truncate text-[12.5px] font-semibold text-aqua-500" data-id="element-51" data-mp="2fmv0yrg3biqg">PROSTHO 360™</p>
              <p className="mt-0.5 text-[11.5px] text-navy-800/55" data-id="element-52" data-mp="2kmhcmwg9sqx5">
                {buyer.location} · {minutes} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-lg p-1 text-navy-800/35 transition-colors duration-150 ease-out hover:bg-navy-800/5 hover:text-navy-800" data-id="element-53" data-mp="2pjhjh9ky1xpb">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="26mpucjiq0odc" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}